module.exports = __webpack_public_path__ + "img/gambling-therapy.e5371c42.png";